export const headers = [
	{
		sortable: true,
		settings: false,
		text: "ID",
		value: "id",
		func: false,
		valueFilter: 'filter_id',
		model: { value: 'list' },
		nowrap: true,
		footer: "count",
	},
	{
		sortable: true,
		settings: false,
		text: "Date from",
		value: "date",
		func: false,
		valueFilter: 'filter_date',
		model: { value: 'list' },
		nowrap: true,
		modValue: 'dateTime2'
	},
	{
		sortable: true,
		settings: false,
		text: "Employee",
		value: "user",
		func: false,
		valueFilter: 'filter_user',
		model: { value: 'list' },
	},
	{
		sortable: true,
		settings: false,
		text: "Issue",
		value: "status_exeption",
		func: false,
		valueFilter: 'filter_status_exeption',
		model: { value: 'list' },
	},
	{
		sortable: true,
		settings: false,
		text: "Description",
		value: "description",
		func: false,
		valueFilter: 'filter_description',
		model: { value: 'list' },
	},
	{
		width: '110px',
		buttons: [
			{
				perm: true,
				withoutPerm: true,
				value: 'view',
				text: 'View',
				icon: { value: 'icon_view', w: 20, h: 20 },
			},
			{
				perm: true,
				withoutPerm: true,
				value: 'edit',
				text: 'Edit',
				icon: { value: 'edit', w: 18, h: 18 },
			},
			{
				perm: true,
				withoutPerm: true,
				value: 'delete',
				text: 'Delete',
				icon: { value: 'deleteItem', w: 18, h: 18 },
			},
		],
	}
];
